enum EmailStatus {
  Pending = 'PENDING',
  Paused = 'PAUSED',
  Processing = 'PROCESSING',
  Canceled = 'CANCELED',
  Finished = 'FINISHED',
  Failed = 'FAILED',
}

export { EmailStatus };
